import { initAnchors } from 'Functions/anchor';
import { initQuestionForm } from 'Functions/question';
import { initRecommendationForm } from 'Functions/recommendation';
import { updateLazy } from 'Functions/lazy';

import "Layouts/default";

import 'Common/lightgallery';
import 'Components/modal/modal-watchdog';

import 'Ui/favorite-trigger';
import "Ui/tabs";
import 'Ui/slider';

document.addEventListener('DOMContentLoaded', function() {
    updateLazy();
    initAnchors();
    initQuestionForm();
    initRecommendationForm();
});